<template>
    <v-menu 
        ref="menuDate"
        v-model="showMenu"
        :close-on-content-click="false"
        :return-value.sync="selectedDateEmit"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :label="custom_field_label"
                v-model="selectedDateText"
                :ref="'f' + custom_field_id"
                :data-qa="'f' + custom_field_id"
                :hint="custom_field_desc"
                persistent-hint

                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                @keydown.tab="updateDate"
            ></v-text-field>
        </template>

        <v-date-picker class="pt-12 h-100" 
            v-model="selectedDate"
            :key="selectedDateText"
            input-class="focus:outline-none"
            no-title
        >
        
        </v-date-picker>

        <v-time-picker
            v-model="selectedTime"
            :key="selectedTime"
            landscape
            input-class="focus:outline-none"
            format="24hr"

        > 
        <v-spacer></v-spacer>

        <div class="w-100 opacity-100">
            <v-btn
                text
                color="primary"
                @click="clearDate()"
            >
                Clear
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="showMenu = false"
            >
                Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="updateDate()"
            >
                OK
            </v-btn>
        </div>

        </v-time-picker>

       
        
    </v-menu>
</template>

<script lang="js">
import { mapGetters } from 'vuex'

export default  {
  name: 'DmDateField',
  props: ['value','custom_field_id','custom_field_label','custom_field_desc'],
  data() {
    return {
        showMenu: false,
        selectedDate: this.ffDateToISO(this.value),
        selectedDateEmit: '',
        selectedTime: this.ffTimeToISO(this.value),
        selectedDateText: this.ffDatetoISOText(this.value),
        //datetimeString: '2019-01-01 12:00'
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
  },
  watch:{
    value(val){
        this.ffDateToISO=val
    }
  },
  methods: {
    updateDate() {
        if(this.selectedTime.length < 6) {
            this.selectedTime+= ':00' //time picker return hh:mm , add manualy seconds
        }
        this.showMenu = false
        this.selectedDateText = this.ffDatetoISOTextUpdate(this.selectedDate , this.selectedTime)
        this.selectedDateEmit = this.selectedDate
        this.$emit('input', this.ffISOtoDate(this.selectedDateEmit)) //send date
    },
    clearDate() {
        this.showMenu = false
        this.selectedDateText = ''
        this.selectedDateEmit = ''
        this.$emit('input', this.ffISOtoDate(this.selectedDateEmit)) //send date
    },
    ffISOtoDate(val){
        if(val) {
            val = val.substring(0,4) + val.substring(5,7) + val.substring(8,10) + this.selectedTime
        }
        else{
            val = ''
        }
        return val
    },
    ffDateToISO(val){
        if(val){
            val = val.substring(0,4) + '-' + val.substring(4,6) + '-' + val.substring(6,8)
        }
        else{
            val=''
        }
        return val
    },
    ffTimeToISO(val){
        if(val){
            val = val.substring(8,16)
        }
        else{
            val = '00:00:00'
        }
        return val
    },
    ffDatetoISOText(val){
        if (val) {
            val = val.substring(6,8) + '.' + val.substring(4,6) + '.'  + val.substring(0,4) + ' ' + val.substring(8,16)
        } else {
            val = ''
        }

        return val
    },
    ffDatetoISOTextUpdate(val,time){
        if(val) {
           val = val.substring(8,10) + '.' + val.substring(5,7) + '.'  + val.substring(0,4) + ' ' + time
        }
        else {
            val=''
        }

        return val
    }
  }
}
</script>

<style scoped lang="scss">
</style>